import React from 'react';

import type { CommonButtonProps } from '../types';
import * as styles from './HyperButton.styles';

export const HyperButton = ({ active, children, ...props }: CommonButtonProps) => (
  <button data-is-active={active} {...props} css={styles.hyperButton}>
    {children}
  </button>
);
